import { Provider, teamsTheme, Loader } from "@fluentui/react-northstar";
import { HashRouter as Router, Redirect, Route } from "react-router-dom";
import { useTeamsFx } from "@microsoft/teamsfx-react";
import Privacy from "./Privacy";
import TermsOfUse from "./TermsOfUse";
import "./App.css";
import TabConfig from "./MeetingTabConfig";
import { TeamsFxContext } from "./Context";
import SettingsTab from "./SettingsTab";
import { useEffect, useState } from "react";
import TenantNotRegistered from "./TenantNotRegistered";
import { isTenantRegistered as apiIsTenantRegistered } from "../apis/cyberGateManagementApi/cyberCareAiClient";
import { config } from '../config'
import MeetingTabConfig from "./MeetingTabConfig";
import MeetingTab from "./MeetingTab";

/**
 * The main app which handles the initialization and routing
 * of the app.
 */
export default function App() {
  const { theme, themeString, teamsfx, inTeams, context } = useTeamsFx({
    "initiateLoginEndpoint": config.startLoginPageUrl,
    "clientId": config.clientID,
  });
  const [isTenantRegistered, setIsTenantRegistered] = useState<boolean>(true);
  const [error, setError] = useState<string>();
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    if (inTeams === true) {
      setLoading(false);
    //   const fetchUserProfile = async () => {
    //     if (!teamsfx) {
    //       return;
    //     }
    //     apiIsTenantRegistered().then((data) => {
    //       setIsTenantRegistered(data);
    //       setLoading(false);
    //       setError(undefined);
    //     })
    //       .catch((error) => {
    //         console.log(error);
    //         setError(error);
    //         setLoading(false);
    //       });;

    //   }

    //   fetchUserProfile()
    //     .catch((error) => {
    //       alert(error);
    //       setError(error)
    //     });;
    }
    else if (inTeams === false) {
      setLoading(false);
    }
  }, [inTeams]);

  const controlToRender = () => {
    if (loading) {
      return <Loader style={{ margin: 100 }} />;
    }
    else if (error) {
      return <div className="error">
        An unexpected error occurred. Please try again later. <br /> Details: {error.toString()}
      </div>;
    }
    else if (inTeams === false) {
      return <div className="error">
        The CyberCare Microsoft Teams App can only be used inside Microsoft Teams.
      </div>;
    }
    else if (inTeams && !isTenantRegistered) {
      return <TenantNotRegistered />;
    }

    return <>
      <Route exact path="/privacy" component={Privacy} />
      <Route exact path="/termsofuse" component={TermsOfUse} />
      <Route exact path="/settingstab" component={SettingsTab} />
      <Route exact path="/meetingtabconfig" component={MeetingTabConfig} />
      <Route exact path="/meetingtab" component={MeetingTab} />
      <Route exact path="/config" component={TabConfig} />
    </>
  }

  return (
    <TeamsFxContext.Provider value={{ theme, themeString, teamsfx, inTeams, context }}>
      <Provider theme={theme || teamsTheme} styles={{ backgroundColor: "#eeeeee" }}>
        <Router>
          <Route exact path="/">
            <Redirect to="/settingstab" />
          </Route>
          {controlToRender()}
        </Router>
      </Provider>
    </TeamsFxContext.Provider>
  );
}
